import { render, staticRenderFns } from "./Editassistindex.vue?vue&type=template&id=026f3459&scoped=true"
import script from "./Editassistindex.vue?vue&type=script&lang=js"
export * from "./Editassistindex.vue?vue&type=script&lang=js"
import style0 from "./Editassistindex.vue?vue&type=style&index=0&id=026f3459&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026f3459",
  null
  
)

export default component.exports